// export let APP_ENV = 'production';
export let APP_ENV = process.env.REACT_APP_ENV;

export const APP_URL = window.location.origin
// export const WEB_APP_URL = 'https://flo-nonnomadic-semblably.ngrok-free.dev'
export const WEB_APP_URL = 'https://app.influns.com'
// export const WEB_APP_URL = 'https://creator.ticktag.ai'
// export const API_BASE_URL = 'https://api.influns.com'
export const PERFX_APP_HOSTNAME = 'perfx.influns.com'
export const isPerfX = window.location.hostname === PERFX_APP_HOSTNAME;
export const APP_NAME = isPerfX ? 'Perfx' : 'influns';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const NODE_APP_URL = 'http://localhost:3010'
export const EXPIRY_TIME_IN_MS = 2 * 24 * 60 * 60 * 1000 // 2 days : days * hours * minutes * seconds * milliseconds
export const LOGO_CDN_URL = isPerfX ? "https://d3esz4e2jyp077.cloudfront.net/app/logo/perfx-main.png" : "https://d3esz4e2jyp077.cloudfront.net/app/logo/influns-logo.png"
export const WHITE_LOGO_CDN_URL = isPerfX ? "https://d3esz4e2jyp077.cloudfront.net/app/logo/perfx-alt.png" : "https://d3esz4e2jyp077.cloudfront.net/app/logo/influnslogoreverse.png"
export const CAMPAIGN_STALE_TIME = 1 * 60 * 1000 // 5 mins : minutes * seconds * milliseconds

export const LANDING_PAGE_URL = 'https://influns.com'

export const REFERRAL_IMG_URL = '/images/refer.png';

export const isDesktopMediaQuery = {
    query: '(min-width: 768px)'
}

export const RAZORPAY_SDK = "https://checkout.razorpay.com/v1/checkout.js";

export const SENTRY_URL = "https://ed5d34ec11e4347deaad01a4f5d5ac7d@o4508552593080320.ingest.us.sentry.io/4508793408389120";

export const TAGLINKS_DEMO_VIDEO_URL = 'https://d3esz4e2jyp077.cloudfront.net/landing/videos/taglinks.mp4';
export const TAGLINKS_ROCKET_IMG = 'https://d3esz4e2jyp077.cloudfront.net/landing/videos/taglinks.png';

export const INIT_IG_AUTH_ROUTE = '/c/ig/ig/init';
export const IG_AUTH_REDIRECT_ROUTE = '/c/ig/ig/r';
export const CAP_IG_AUTH_REDIRECT_ROUTE = '/cap/c/ig/ig/r';
export const IG_HANDLE_INPUT_ROUTE = '/c/ig/handle'
export const IG_HANDLE_VERIFICATION_ROUTE = '/c/ig/handle/verify'

export const NEW_IG_AUTH_METHOD = true;
export const IG_HELPDESK_URL = 'https://help.influns.com/en/creator/instagram';

export const GOOGLE_MAPS_API_KEY='AIzaSyARbYQLEKqJAag3lLkliWIfEwAjKerMjnM'
export const GOOGLE_MAPS_API_KEY_APP='AIzaSyBxHIdD_eIIOR6F0PipbDLH6X2HMSrUcQk'
export const GENERAL_GIGTYPE_ID=6
export const GA_MEASUREMENT_ID = 'G-BYGZ314CDE';
export const platforms = {
    ig: { id: 'ig', name: 'Instagram' },
    yt: { id: 'yt', name: 'YouTube' },
}

export const MOBILE_APP_URLS = {
    'android': 'https://play.google.com/store/apps/details?id=com.influns.app',
    'ios': 'https://apps.apple.com/in/app/influns/id6756166634'
}

export const APP_REVIEW_REQUEST_TIME_PERIOD = 30 * 24 * 60 * 60 * 1000; // 30 days
export const APP_REVIEW_REQUEST_TIMESTAMP_KEY = 'reviewRequestedAt';
export const FREE_SUBSCRIPTION_PLAN_ID = 1;

export const HEADER_CHAT_ICON_SUPPORTED_ROUTES = [
    '/',
    '/collaborations',
    '/applications',
]

export const colors = {
    primary: 'var(--primary)'   
}

export const WHATSAPP_SUPPORT_NUMBER = '919266391960';